import { generatePath } from "@/routes/utils";

const basePath = "types/";
const contentPath = `${basePath}content-type/`;
const genderPath = `${basePath}gender-type/`;

// وضعیت تحصیلی
const educationalStatusPath = `${basePath}educational-status-type/`;
// مدرک تحصیلی
const degreePath = `${basePath}degree-type/`;
// نوع کتاب
const memberBookPath = `${basePath}member-book-type/`;
// وضعیت پروژه
const labProjectStatusPath = `${basePath}lab-project-status-type/`;
// مرتبه علمی
const memberRankPath = `${basePath}member-rank-type/`;
// نوع مقاله
const paperPath = `${basePath}paper-type/`;
// نوع کارمند
const staffType = `${basePath}staff-profile-type/`;

export const types = {
  content: {
    getAll: () => generatePath(contentPath, null),
  },
  gender: {
    getAll: () => generatePath(genderPath, null),
  },
  degree: {
    getAll: () => generatePath(degreePath, null),
  },
  educationalStatus: {
    getAll: () => generatePath(educationalStatusPath, null),
  },
  labProject: {
    getAll: () => generatePath(labProjectStatusPath, null),
  },
  memberBook: {
    getAll: () => generatePath(memberBookPath, null),
  },
  memberRank: {
    getAll: () => generatePath(memberRankPath, null),
  },
  paper: {
    getAll: () => generatePath(paperPath, null),
  },
  staffProfileType: {
    getAll: () => generatePath(staffType, null),
  },
};
